import * as Styles from '@screens/landing-page-tools/styles';
import * as Accordion from '@radix-ui/react-accordion';
import { TabContent } from '@screens/landing-page-tools/types';
import TabAccordionItem from '@screens/lp-default/components/tools/components/tab-accordion-item';
import DoctorImage from '@screens/lp-default/components/tools/components/doctor-image';
import { snowplowButtonClick } from '@analytics/snowplow/events';
import { useState } from 'react';

type props = {
  screenData: TabContent;
};

export default function LandingPageTools({ screenData }: props) {
  const [currentOpenAccordion, setCurrentOpenAccordion] = useState(screenData.accordions[0].title);

  const handleAccordionClick = (tab: string, title: string, position: number) => {
    const isAlreadyOpen = title === currentOpenAccordion;
    snowplowButtonClick('accordion', '/planos', isAlreadyOpen ? 'close' : 'open', `${tab}_${position + 1}`);
  };

  return (
    <>
      <Styles.Container data-testid="landing-page-tools">
        <Styles.FadeOverlay />
        <Styles.TabTitle>{screenData.title}</Styles.TabTitle>
        <Styles.Content>
          <Styles.InfoWrapper>
            <Styles.InfoTitle>Como atingir seu objetivo</Styles.InfoTitle>
            <Accordion.Root
              type="single"
              defaultValue={screenData.accordions[0].title}
              onValueChange={setCurrentOpenAccordion}
            >
              {screenData.accordions.map((accordion, index) => (
                <>
                  <TabAccordionItem
                    key={accordion.title}
                    tab={screenData.tab}
                    accordion={accordion}
                    onClick={() => handleAccordionClick(screenData.tab, accordion.title, index)}
                  />
                  {index < screenData.accordions.length - 1 && <Styles.Divider />}
                </>
              ))}
            </Accordion.Root>
          </Styles.InfoWrapper>
          <DoctorImage images={screenData.images} />
        </Styles.Content>
      </Styles.Container>
    </>
  );
}
